import React, {FC} from 'react'
import {CardInterface} from '../../../../app/@types'

const Card: FC<CardInterface> = ({
                                   id,
                                   title,
                                   body,
                                   footer,
                                   size,
                                   toolbar = <></>,
                                   bodyChildren = <></>,
                                 }) => {

  const sm = size === 'sm'

  return (
    <>
      <div className="card" id={id}>

        <div className={`card-header py-3 ${sm && 'min-h-50px bg-light-info'}`}>
          <div className="card-title flex-column">
            <div className="fw-bolder mb-2 fs-5 fs-sm-3">{title}</div>
            {bodyChildren}
          </div>
          <div className="card-toolbar d-flex justify-content-between align-items-end flex-column">
            {toolbar}
          </div>
        </div>
        <div className="card-body p-5 p-sm-8">
          {body}
        </div>
        {
          footer && <div className="card-footer">{footer}</div>
        }

      </div>
    </>
  )
}

export {Card}